export default __webpack_public_path__ + "static/nus-law-857236d4b9444c4039e90e8d4940e97a.png";